import React from 'react'
import { useNavigate } from 'react-router-dom'

function NotFound() {
  const redirect=useNavigate()
  const red=()=>{
    redirect("/")
  }
  return (
    <>
    <h1 className='display-4'>error 404 page cannot be diplayed</h1>
    <button className='btn btn-danger' onClick={red}>go to our official website </button>
    </>
  )
}

export default NotFound